<script lang="ts">
  import IconRight from '@/comps-sdk/components/icon/arrow-right.svelte';

  export let disabled = false;
  export let label = '';
  export let defaultText = '请选择';
  export let selectedValue = {
    id: '',
    name: '',
  };

  let showText = '';

  $: {
    showText = selectedValue.name || defaultText;
  }
</script>

<div class="select-row-wrapper" class:select-disabled={disabled}>
  <div class="row-label">
    {label}
  </div>
  <div role="button" tabindex="0" class="right-wrapper" on:click on:keyup={() => {}}>
    <div class="row-default-text">
      {showText}
    </div>
    {#if !disabled}
      <div class="row-select-icon">
        <IconRight />
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .select-row-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    &.select-disabled {
      pointer-events: none;
      padding-right: 16px;
    }
    .row-label {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #191919;
    }
    .right-wrapper {
      display: flex;
      align-items: center;
      .row-default-text {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(25, 25, 25, 0.5);
      }
    }
  }
</style>
